import { Table, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

import { colors } from "goi_common";

const MissParlorDetailFuneralProcessTable = () => {
  return (
    <Table>
      <Tbody>
        <Tr>
          <MissParlorDetailTableTh>빈소</MissParlorDetailTableTh>
          <Tr>
            <MissParlorDetailTableTh>장례식장 결정</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              상담을 마친 뒤, 조문객을 맞이할 장소를 배정받고 관련 서류에
              서명합니다. 고인의 종교와 유가족의 의사를 반영하여 장례 일정과
              진행 방식을 결정합니다. (장례 순서와 출발 시각 포함) 화장을
              선택하신 경우, 유족과 상의 후 최대한 빠르게 예약을 진행해
              드리겠습니다.
            </ParlorDetailTableTd>
          </Tr>
          <Tr>
            <MissParlorDetailTableTh>영정사진</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              영정용으로 별도로 준비된 사진이 없을 경우, 고인의 평상시 모습이
              담긴 일반 사진을 크게 인화하여 사용하셔도 무방합니다.
            </ParlorDetailTableTd>
          </Tr>
          <Tr>
            <MissParlorDetailTableTh>물품 및 서비스</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              식음료, 제단 장식, 예복까지 물품들을 이용하실 수 있습니다. 주방
              일손이 더 필요하시다면 미리 말씀해 주시면 인력을 보강해드립니다.
            </ParlorDetailTableTd>
          </Tr>
        </Tr>
        <Tr>
          <MissParlorDetailTableTh>염습, 입관</MissParlorDetailTableTh>
          <Tr>
            <MissParlorDetailTableTh>염습, 입관시간</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              고인을 관에 안치하는 절차가 이어집니다. 단, 여러 장례가 동시에
              진행될 경우 입관 시간이 약간 변경될 수 있음을 양해 부탁드립니다.
            </ParlorDetailTableTd>
          </Tr>
          <Tr>
            <MissParlorDetailTableTh>제반서류</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              입관 절차를 시작하기 위해서는 사망을 공식적으로 확인하는
              서류(사망진단서 혹은 검안서)를 미리 제출해 주셔야 합니다.
            </ParlorDetailTableTd>
          </Tr>
        </Tr>

        <Tr>
          <MissParlorDetailTableTh>발인</MissParlorDetailTableTh>
          <Tr>
            <MissParlorDetailTableTh>비용정산</MissParlorDetailTableTh>
            <ParlorDetailTableTd>
              비용 정산은 발인 당일 혹은 그 이전에 진행됩니다.
            </ParlorDetailTableTd>
          </Tr>
        </Tr>
      </Tbody>
    </Table>
  );
};

const MissParlorDetailTableTh = ({ children }: PropsWithChildren<object>) => {
  return (
    <Th
      css={{
        padding: "10px",
        width: "70px",
        borderRight: `1px solid ${colors.gray100}`,
      }}
    >
      {children}
    </Th>
  );
};

const ParlorDetailTableTd = ({ children }: PropsWithChildren<object>) => {
  return <Td className="caption_12_r lg_body_14_r">{children}</Td>;
};

export default MissParlorDetailFuneralProcessTable;
